import React from 'react';

import { observer } from 'mobx-react';

import { RiskMatrixDisplay, RiskMatrixValue, isRated } from 'components/RiskMatrix';
import CustomFieldDisplayValue from 'components/SharedFormComponents/CustomFieldDisplayValue';
import { EmptyValue } from 'components/SharedFormComponents/CustomFieldDisplayValue/styles';
import { Value } from 'components/SharedFormComponents/EditableTextInput/styles';
import type { EntitiesStores } from 'components/Entities/types';

import { ProtectorType } from 'core/constants';

import type { EntityEnumsOptions } from 'utils/api/modules/entities/entities.types';
import type { AnswerTypes } from 'utils/api/modules/incidents/incidents.types';

const Empty = (): React.ReactElement => <EmptyValue id="empty-value">-</EmptyValue>;

const RiskHeaderValue: React.FunctionComponent<{ store: EntitiesStores; fieldKey: string }> = ({ store, fieldKey }) => {
  const field = store.store.entityFields.getFieldById(fieldKey, store.details?.entity[fieldKey]?.value);
  if (!field || field.value === null || field.value === undefined) {
    return <Empty />;
  }

  const type = field.schema.protectorType as ProtectorType;

  if (type === ProtectorType.RiskFactor) {
    const rating = field.value as unknown as RiskMatrixValue | null;
    return isRated(rating) ? <RiskMatrixDisplay value={rating} dense /> : <Empty />;
  }

  if (type === ProtectorType.SingleChoice || type === ProtectorType.MultiChoice) {
    const labels = (field.value as EntityEnumsOptions[]).map((option) => option.value);
    return labels.length ? <Value>{labels.join(', ')}</Value> : <Empty />;
  }

  return <CustomFieldDisplayValue value={field.value as unknown as AnswerTypes} type={type} schema={field.schema} />;
};

export default observer(RiskHeaderValue);
